import React, { useEffect, useState } from 'react';
import Styles from '../Socials.module.scss';
import { getTiktokAuthUrl } from 'services/integrationService';
import { SiTiktok } from 'react-icons/si';
import {
  error as errorToast,
  success as successToast,
} from 'helpers/toaster.js';
import ErrorModal from 'Components/Modal/CampaignErrorModal/CampaignErrorModal';
import { useSelector } from 'react-redux';
import { getRequest } from 'helpers/axios';
import UpgradeModal from 'Containers/Modal/UpgradeModal/UpgradeModal';

const TiktokLoginForm = ({ onLoginSuccess }) => {
  const [errorModal, setErrorModal] = useState(false);
  const [errorDetails, setErrorDetails] = useState({ message: '', link: '' });
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const { current_subscription: currentSubscription } =
    user?.subscriptions ?? {};

  const handleTiktokClick = async () => {
    try {
      const limitResponse = await getRequest(
        'check_limits?type=platform_integration',
      );

      if (!limitResponse.data.success) {
        if (currentSubscription?.plan_name === 'Basic Plan') {
          setShowUpgradeModal(true);
          return;
        } else {
          setErrorDetails({
            message:
              limitResponse.data.message ||
              'You have reached your platform integration limit',
            link: limitResponse.data.link || '',
          });
          setErrorModal(true);
          return;
        }
      }

      // Get auth URL from backend
      const response = await getTiktokAuthUrl();
      const authUrl = response.data.auth_url;

      if (!authUrl) {
        errorToast('Failed to get TikTok authorization URL');
        return;
      }

      // Open popup for TikTok OAuth
      const width = 600;
      const height = 700;
      const left = window.innerWidth / 2 - width / 2;
      const top = window.innerHeight / 2 - height / 2;
      const windowOptions = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`;
      window.open(authUrl, 'TikTok Auth', windowOptions);
    } catch (error) {
      setErrorDetails({
        message:
          error.response?.data?.error ||
          'You have reached your platform integration limit',
        link: 'https://appsumo.com/products/vocable-ai',
      });

      if (currentSubscription?.plan_name === 'Basic Plan') {
        setShowUpgradeModal(true);
      } else {
        setErrorModal(true);
      }
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data || typeof event.data !== 'object') return;

      if (event.data.type === 'TIKTOK_SUCCESS') {
        onLoginSuccess();
        successToast('TikTok account connected successfully!');
      } else if (event.data.type === 'TIKTOK_ERROR') {
        const payload = event.data.payload || {};
        errorToast(payload.message || 'Failed to connect TikTok');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onLoginSuccess]);

  return (
    <>
      <div
        className={`${Styles.IntegrationBtn} rounded-4`}
        onClick={handleTiktokClick}
      >
        <SiTiktok style={{ width: '2rem', height: '2rem' }} color="#000000" />
        <p>TikTok</p>
      </div>

      {showUpgradeModal && (
        <UpgradeModal
          show={showUpgradeModal}
          onHide={() => setShowUpgradeModal(false)}
        />
      )}

      {errorModal && (
        <ErrorModal
          show={errorModal}
          onHide={() => setErrorModal(false)}
          errorMessage={errorDetails.message}
          errorLink={errorDetails.link}
        />
      )}
    </>
  );
};

export default TiktokLoginForm;
